import { Component, EventEmitter, HostListener, Input, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { InvoiceService } from 'src/app/services/invoice.service';
import { HelpersService } from 'src/app/services/helpers.service';

@Component({
  selector: 'app-workshop-jobcard-edit-lineitem',
  templateUrl: './workshop-jobcard-edit-lineitem.component.html',
  styleUrls: ['./workshop-jobcard-edit-lineitem.component.scss']
})
export class WorkshopJobcardEditLineitemComponent {

  @Input() public jobcard: any = {};
  @Input() public lineItem: any = {};
  @Input() public allowDiscount: boolean = false;
  @Input() public vatInclusive: boolean = false;
  @Input() public lightSpeedDiscounts: any[] = [];
  @Output() public lineItemUpdated: EventEmitter<any> = new EventEmitter<any>();


  public quantity: number = 0;
  public price: number = 0;
  public discount: number = 0;
  public discountID: number = 0;
  public discountType: string = 'NONE';  
  public discounts: any[] = [];

  constructor(
    public activeModal: NgbActiveModal,
    private invoiceService: InvoiceService,
    private helpersService: HelpersService
  ) { }

  ngOnInit() {
    console.log(this.lineItem)
    this.lineItem = JSON.parse(JSON.stringify(this.lineItem)); // Create a deep copy of the lineItem to avoid mutating the original object
    this.quantity = this.lineItem.Quantity || 1;
    this.price = this.vatInclusive ? this.lineItem.UnitPrice_IncludingTax.toFixed(2) : this.lineItem.UnitPrice.toFixed(2);
    this.discount = this.lineItem.Discount ? parseFloat(this.lineItem.Discount.toFixed(2)) : 0;
    this.discountID = this.lineItem.DiscountID;
    this.getDiscountType();
  }

  getDiscountType() {
    var partnerData = this.helpersService.getPartnerData();
    this.discountType =
      partnerData.POSSystemID === 6
        ? 'LIGHTSPEED-R'
        : partnerData.POSSystemID === 3 ||
          partnerData.POSSystemID === 8 ||
          partnerData.POSSystemID === 9 ||
          partnerData.POSSystemID === 14 ||
          partnerData.POSSystemID === 11 ||
          partnerData.POSSystemID === 12 ||
          partnerData.POSSystemID === 13 ||
          partnerData.POSSystemID <= 0
          ? 'AMOUNT'
          : 'NONE';
    if (this.discountType === 'LIGHTSPEED-R') {
      this.mapLightSpeedDiscounts();
    }
  }

  mapLightSpeedDiscounts() {
    var discounts = this.lightSpeedDiscounts;
    this.discounts.push({ label: '0%', value: 0 });
    if (discounts && discounts.length > 0) {
      discounts.forEach((discount) => {
        this.discounts.push({
          label: discount.Name,
          value: parseInt(discount.ID),
        });
      });
    }
    this.discountID = null;
    setTimeout(() => {
      this.discountID = this.lineItem.DiscountID;
    }, 0); // Delay to ensure the view is initialized before setting the discountID
  }


  applyChanges() {
    this.lineItem = { ...this.lineItem, Quantity: this.quantity, HasBeenUpdated : true };

    //Only update this if the ychanged the price
    if (this.vatInclusive && this.price != this.lineItem.UnitPrice_IncludingTax || !this.vatInclusive && this.price != this.lineItem.UnitPrice) {
      var taxRate = this.lineItem.TaxRate || this.lineItem.Tax > 0 ? (this.lineItem.Tax / this.lineItem.UnitPrice) : 0;
      if (this.vatInclusive) {
        this.lineItem.UnitPrice_IncludingTax = parseFloat(this.price.toString());
        this.lineItem.UnitPrice = this.lineItem.UnitPrice_IncludingTax / (1 + taxRate);
        this.lineItem.TaxRate = taxRate;
        this.lineItem.Tax = this.lineItem.UnitPrice_IncludingTax - this.lineItem.UnitPrice;
      } else {
        this.lineItem.UnitPrice = parseFloat(this.price.toString());
        this.lineItem.UnitPrice_IncludingTax = this.lineItem.UnitPrice * (1 + taxRate);
        this.lineItem.TaxRate = taxRate;
        this.lineItem.Tax = this.lineItem.UnitPrice_IncludingTax - this.lineItem.UnitPrice;
      }
    }

    if (this.jobcard.quote.couponDiscountType === 'PERCENT') {
      this.lineItem.Discount = this.vatInclusive ? this.lineItem.UnitPrice_IncludingTax * (this.jobcard.quote.couponDiscount / 100) : this.lineItem.UnitPrice * (this.jobcard.quote.couponDiscount / 100);
      this.lineItem.TotalDiscount = this.lineItem.Discount * this.lineItem.Quantity;
    } else if (this.jobcard.quote.couponDiscountType === 'FIXED') {
      this.lineItem.Discount = this.discount;
      if (this.discount > this.price) {
        this.lineItem.Discount = this.price;
      }
      this.lineItem.TotalDiscount = this.lineItem.Discount;
    } else if (this.lineItem.DiscountType === 'PERCENT' && this.lineItem.DiscountPercent) {
      this.lineItem.Discount = this.vatInclusive ? this.lineItem.UnitPrice_IncludingTax * (this.lineItem.DiscountPercent / 100) : this.lineItem.UnitPrice * (this.lineItem.DiscountPercent / 100);
      this.lineItem.TotalDiscount = this.lineItem.Discount * this.lineItem.Quantity;
    } else {
      this.lineItem.Discount = this.discount;
      if (this.discount > this.price) {
        this.lineItem.Discount = this.price;
      }
      this.lineItem.TotalDiscount = this.discount;
    }

    const index = this.jobcard.quote.lineItems.findIndex(item => item.InternalProductID === this.lineItem.InternalProductID);

    if (index > -1) {
      this.jobcard.quote.lineItems[index] = this.lineItem;
    }
    this.lineItemUpdated.emit(this.lineItem);
    this.activeModal.close();
  }

  removeLineItem() {
    if (this.jobcard && this.jobcard.quote && this.lineItem) {
      const index = this.jobcard.quote.lineItems.findIndex(item => item.InternalProductID === this.lineItem.InternalProductID);
      if (index > -1) {
        this.jobcard.quote.lineItems.splice(index, 1);
      }
    }
    this.activeModal.close();
  }

  valid() {
    return this.quantity > 0 && this.price >= 0;
  }

  @HostListener('keydown', ['$event'])
  onKeydown(event: KeyboardEvent) {
    if (event.key === 'Enter' && this.valid()) {
      this.applyChanges();
    } else if (event.key === 'Escape') {
      this.activeModal.dismiss('cancel');
    }
  }

  clearDiscount() {
    this.discount = 0;
    this.discountID = null;
    this.lineItem.Discount = null;
    this.lineItem.TotalDiscount = null;
    this.lineItem.DiscountID = null;
    this.lineItem.DiscountType = null;
    this.lineItem.CouponDiscountApplied = false;
    this.lineItem.DiscountPercent = null;
  }

  discountSelected(discountID: any) {
    if (discountID === 0) {
      this.clearDiscount();
      return;
    }
    const discount = this.lightSpeedDiscounts.find(d => d.ID === discountID.toString());
    if (discount) {
      this.discountID = discountID;
      if (parseFloat(discount.DiscountAmount) > 0) {
        this.discount = parseFloat(discount.DiscountAmount);
      } else if (parseFloat(discount.DiscountPercent) > 0) {
        this.discount = this.vatInclusive ? this.lineItem.UnitPrice_IncludingTax * (parseFloat(discount.DiscountPercent)) : this.lineItem.UnitPrice * (parseFloat(discount.DiscountPercent));
      }
      this.lineItem.Discount = this.discount;
      this.lineItem.TotalDiscount = this.lineItem.Discount * (parseFloat(discount.DiscountPercent) > 0 ? this.lineItem.Quantity : 1);
      this.lineItem.DiscountID = discountID;
      this.lineItem.DiscountType = parseFloat(discount.DiscountAmount) > 0 ? 'FIXED' : 'PERCENT';
      this.lineItem.CouponDiscountApplied = false;
      this.lineItem.DiscountPercent = this.lineItem.DiscountType === 'PERCENT' ? parseFloat(discount.DiscountPercent) * 100 : null;
    }
  }

  canEditLineItemQuatity(lineItem: any): boolean {
    return !this.jobcard.id || !(this.jobcard.id && lineItem.InternalProductID == 0 && lineItem.ExternalKey !== null && lineItem.ExternalKey !== '' && lineItem.IsLabor)
  }

}
